import React, {Component} from 'react';
import {observer, Provider, inject } from "mobx-react";
import commentsStore from "../../stores/commentsStore";
import Comments from "./Comments";
import historyVars from "../../utils/historyVars";


class CommentsWithStore extends Component {
  constructor(props) {
    super(props);
    this._commentsStore=new commentsStore(null, { comment_url_var: props.comment_url_var });
    if(this.props.limit) {
      this._commentsStore.limit=parseInt(this.props.limit);
      this._commentsStore.initial_limit=parseInt(this.props.limit);
    }
    if(this.props.readonly) {
      this._commentsStore.readonly = true;
    }
    if(this.props.standalone) {
      this._commentsStore.standalone = true;
    }
    if(this.props.editor_css) {
      this._commentsStore.editor_css = this.props.editor_css;
    }
    this._commentsStore.setRootElement(this.props.category, this.props.element);
    if(this.props.topic_starter) {
      this._commentsStore.setTopicStarter(this.props.topic_starter);
    }
    this._commentsStore.loadComments(true).then(()=>{
      setTimeout(()=>{
        this._commentsStore.moveToSelectedComment();
      },300);
    });

    if(this.props.lang) {
      this.props.translateStore.lang=this.props.lang;
    }
    if(this.props.small_mode) {
      this._commentsStore.small_mode=true;
    }

    window.setSmallMode=(code,mode)=>{
      console.log('cur_code',this.props.code);
      if(this.props.code==code || !code) {
        this._commentsStore.small_mode=mode;
      }
    }
  }

  componentWillUnmount() {
    this._commentsStore.destruct();
    historyVars.appendVars({ comment:"" });
  }
  componentDidMount() {
    if(!this.props.meStore.me.inited) {
      if(this.props.translateStore.lang == "ru") {
        this.props.translateStore.fetchTranslate();
      }
      this.props.meStore.fetchMe();
    }
  }

  render() {
    if(!this.props.meStore.me.inited || !this.props.translateStore.translate.inited) {
      return null;
    }
    return (
      <div>
        <Provider commentsStore={this._commentsStore}>
          <div className={`${this._commentsStore.small_mode?'hpadd5':'hpadd20'}`}>
            <Comments />
          </div>
        </Provider>
      </div>
    )
  }
}

export default inject("meStore","translateStore")(observer(CommentsWithStore));